import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { menuInterface } from '../models/menu.model';
import { GetModulesResponse } from '../models/modules.model';
@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(
    private http: HttpClient,
  ) { }

public optionsmenu(value: GetModulesResponse['modulosActivos']): Observable<GetModulesResponse['modulosActivos']> {
    return of(value);
  }

  // public optionsmenu(): Observable<menuInterface> {
  //   return this.http.get<menuInterface>('../assets/json/menu.json');
  // }
}
